// extracted by mini-css-extract-plugin
module.exports = {"loader-image":"Loader_loader-image__3K3uq","rotation":"Loader_rotation__2IzO5"};